export default "__VITE_ASSET__3c4be1f8__"